/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaderboardRecurrenceConfigResponse
 */
export interface LeaderboardRecurrenceConfigResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardRecurrenceConfigResponse
     */
    isRecurring: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LeaderboardRecurrenceConfigResponse
     */
    autoRestartOnEnd: boolean;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardRecurrenceConfigResponse
     */
    maxPeriods?: number;
}

/**
 * Check if a given object implements the LeaderboardRecurrenceConfigResponse interface.
 */
export function instanceOfLeaderboardRecurrenceConfigResponse(value: object): value is LeaderboardRecurrenceConfigResponse {
    if (!('isRecurring' in value) || value['isRecurring'] === undefined) return false;
    if (!('autoRestartOnEnd' in value) || value['autoRestartOnEnd'] === undefined) return false;
    return true;
}

export function LeaderboardRecurrenceConfigResponseFromJSON(json: any): LeaderboardRecurrenceConfigResponse {
    return LeaderboardRecurrenceConfigResponseFromJSONTyped(json, false);
}

export function LeaderboardRecurrenceConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardRecurrenceConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isRecurring': json['isRecurring'],
        'autoRestartOnEnd': json['autoRestartOnEnd'],
        'maxPeriods': json['maxPeriods'] == null ? undefined : json['maxPeriods'],
    };
}

export function LeaderboardRecurrenceConfigResponseToJSON(json: any): LeaderboardRecurrenceConfigResponse {
    return LeaderboardRecurrenceConfigResponseToJSONTyped(json, false);
}

export function LeaderboardRecurrenceConfigResponseToJSONTyped(value?: LeaderboardRecurrenceConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isRecurring': value['isRecurring'],
        'autoRestartOnEnd': value['autoRestartOnEnd'],
        'maxPeriods': value['maxPeriods'],
    };
}

